module.exports = __webpack_public_path__ + "static/img/gongzhonghao.49dce931.jpg";